import script from "./PageLove.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLove.vue?vue&type=script&setup=true&lang=js"

import "./PageLove.vue?vue&type=style&index=0&id=3ba08f8e&lang=css"

const __exports__ = script;

export default __exports__